import React, { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../components/Logo/Logo';
import SEOHead from '../components/SEO/SEOHead';
import './MaintenancePage.css';

const SUPPORT_EMAIL = 'contact@rintintin.fr';

const MaintenancePage: React.FC = () => {
  const { t } = useTranslation('common');
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRetry = useCallback(() => {
    setIsRefreshing(true);
    window.location.reload();
  }, []);

  return (
    <>
      <SEOHead
        title="Maintenance — Rintintin Pro"
        description="Rintintin Pro est temporairement en maintenance."
        noindex
      />
      <div className="maintenance-page">
        <main className="maintenance-card" role="main" aria-labelledby="maintenance-heading">
          <header className="maintenance-header">
            <Logo fontSize="2rem" className="maintenance-logo" />
            <div className="maintenance-status" role="status" aria-live="polite">
              <span className="maintenance-status__dot" aria-hidden />
              {t('maintenancePage.status')}
            </div>
          </header>

          <div className="maintenance-hero" aria-hidden>
            <span className="maintenance-hero__emoji">🐾</span>
          </div>

          <h1 id="maintenance-heading" className="maintenance-title">
            {t('maintenancePage.title')}
          </h1>

          <p className="maintenance-lead">{t('maintenancePage.lead')}</p>

          <ul className="maintenance-checklist">
            <li>
              <span className="maintenance-checklist__icon" aria-hidden>
                ✓
              </span>
              <span>{t('maintenancePage.checklist.dataIntact')}</span>
            </li>
            <li>
              <span className="maintenance-checklist__icon" aria-hidden>
                ✓
              </span>
              <span>{t('maintenancePage.checklist.autoReconnect')}</span>
            </li>
            <li>
              <span className="maintenance-checklist__icon" aria-hidden>
                ✓
              </span>
              <span>{t('maintenancePage.checklist.comeBack')}</span>
            </li>
          </ul>

          <div className="maintenance-actions">
            <button
              type="button"
              className="maintenance-btn maintenance-btn--primary"
              onClick={handleRetry}
              disabled={isRefreshing}
            >
              {isRefreshing ? t('maintenancePage.retrying') : t('maintenancePage.retryButton')}
            </button>
            <Link to="/" className="maintenance-btn maintenance-btn--secondary">
              {t('maintenancePage.backToSite')}
            </Link>
          </div>

          <footer className="maintenance-footer">
            <p className="maintenance-footer__label">{t('maintenancePage.footerLabel')}</p>
            <a className="maintenance-footer__link" href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>
          </footer>
        </main>
      </div>
    </>
  );
};

export default MaintenancePage;
